import React,{useState,useEffect, useRef} from 'react'
import { Form,Modal, Input,DatePicker,message, } from 'antd'
import dayjs from 'dayjs';
import MyEditor from '../cpn/MyEditor';
import { useRenwuAddMutation } from '../store/BnsKeJiApi';
import GetUser from '../cpn/GetUser';
import {FileAddOutlined,} from '@ant-design/icons';
function TaskAddCopy(props) {  
    const [open,setOpen] = useState()
    const [info,setInfo] = useState({
        rw_content:'',
        rw_dept_id:'',
        rw_e_id:'',
        rw_end_date:'',
        rw_fb_uid:'',
        rw_fb_uname:'',
        rw_js_uid:'',
        rw_js_uname:'',
        rw_name:'',
        rw_state:'1',
        rw_uid:'',
        rw_uname:'',
    });
    
    const editForm = useRef();
    useEffect(() => {
        if(props && open){
            editForm.current.setFieldsValue({
                rw_date:dayjs(props.rw_date),
                rw_content:props.rw_content,
                rw_name:props.rw_name,  
                rw_js_uname:props.rw_js_uname,               
                rw_end_date:dayjs(props.rw_end_date),               
            });
        }
        setInfo(prevState=>({...prevState,
            rw_content:props.rw_content,
            rw_dept_id:props.rw_dept_id,
            rw_e_id:props.e_id,
            rw_end_date:props.rw_end_date,
            rw_fb_uid:props.eu_id,
            rw_fb_uname:props.eu_name,
            rw_js_uid:props.rw_js_uid,
            rw_js_uname:props.rw_js_uname,
            rw_name:props.rw_name,
            rw_state:'1',
            rw_uid:props.eu_id,
            rw_uname:props.eu_name,
        }))
    },[props,open])
    const [add] = useRenwuAddMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><FileAddOutlined /> 新增</a>
            <Modal
                open={open}
                title='新增任务'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                width={1000}
                onOk={() => {
                      add(info).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                   
                }}
            >
                <Form
                    labelCol={{span:3}}
                    wrapperCol={{span:21}}   
                    ref={editForm}                 
                >
                    <Form.Item
                        label='任务标题'
                        name='rw_name'
                    >
                        <Input
                            onChange={(e) => {setInfo(prev => ({...prev,rw_name:e.target.value}))}}
                        />
                    </Form.Item>
                    <Form.Item
                        label='任务正文'
                        name='rw_content'
                    >
                        <MyEditor 
                            height='400px'
                            onChange={(e) => {setInfo(prev => ({...prev,rw_content:e}))}}
                        />
                    </Form.Item>
                    <GetUser
                        label='执行人'
                        getUser={(e,f) => {
                            console.log(e,f);                        
                            setInfo(prev => ({...prev,rw_js_uid:e,rw_js_uname:f}))
                        }}
                        wrapperCol={{span:'4'}}
                        name='rw_js_uname'

                    />
                    <Form.Item
                        label='截止日期'
                        name='rw_end_date'
                    >
                        <DatePicker
                            onChange={(e) => {setInfo(prev => ({...prev,rw_end_date:dayjs(e).format('YYYY-MM-DD')}))}}
                        />
                    </Form.Item>                  
                </Form>
            </Modal>
        </>
    )
}

export default TaskAddCopy